export default {
    recommProductsList:[//推荐产品
        {name:"采购溯源系统",routeUrl: "/softwareproducts/purchase",icon:"iconfont icon-zu405-17"},
        // {name:"统采统配系统",routeUrl: "",icon:"iconfont icon-zu405-16"},
        {name:"食堂管理系统",routeUrl: "/softwareproducts/canteen",icon:"iconfont icon-zu405-15"},
        {name:"大数据监管系统",routeUrl: "/softwareproducts/bigdata",icon:"iconfont icon-zu405-14"},
        // {name:"宣传系统",routeUrl: "",icon:"iconfont icon-zu405-13"},
        {name:"培训系统",routeUrl: "/softwareproducts/train",icon:"iconfont icon-zu405-12"},
    ],//
    recommSHList:[//推荐智能硬件
        {name:"电子智能秤",routeUrl: '/equipment/dzc',icon:"iconfont icon-zu405-06"},
        {name:"晨检仪",routeUrl: "/equipment/cjy",icon:"iconfont icon-zu405-07"},
        {name:"AI视觉分析",routeUrl: "/equipment/sjfx",icon:"iconfont icon-zu405-08"},
        {name:"智能留样柜",routeUrl: "/equipment/znlyg",icon:"iconfont icon-zu405-09"},
        {name:"农产快检仪",routeUrl: "/equipment/nckjy",icon:"iconfont icon-zu405-10"},
        {name:"信息公示屏",routeUrl: "/equipment/xxgsp",icon:"iconfont icon-zu405-11"},
    ],//
}
